class SubscriptionPreloaderCtrl {
  close() {
    this.closeModal();
  }
}

export default SubscriptionPreloaderCtrl;
